import React from 'react';
import AuthLayout from 'components/Auth/AuthLayout';
import ForgotPasswordForm from 'components/Auth/ForgotPasswordForm';
import { useAuthProvider } from 'providers/AuthProvider';
import { ForgotPasswordFormData } from 'components/Auth/ForgotPasswordForm/validateForgotPasswordForm';
import notification from 'handlers/notification/notificationActionCreator';
import getMessage, { MessageType } from 'constants/messages';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { AppRoutes } from 'routes/RouteService';

const ForgotPassword = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const authProvider = useAuthProvider();

  const handleSubmit = async ({ email }: ForgotPasswordFormData) => {
    await authProvider.sendForgotPasswordLink(email);

    notification.createNotification(getMessage(MessageType.PasswordResetEmailSent, { email }), 'success', dispatch);

    history.push(AppRoutes.SignIn);
  };

  return (
    <AuthLayout
      title="Reset Password"
      subTitle="Please enter your email address, and we’ll send you a link to reset your password."
    >
      <ForgotPasswordForm onSubmit={handleSubmit} />
    </AuthLayout>
  );
};

export default ForgotPassword;
